import { useEffect } from 'react';

import { Box, ChevronBackButton, FilterButton } from '@opendoor/bricks-next';
import type { AddressSearchResultFragment } from '__generated__/athena';
import { useNavMenu } from 'components/landing-pages-v2/shared/NavMenuContext';
import { MapLocationSearch } from 'components/marketplace/map/LocationSearch';
import { SAVED_SEARCHES_ENABLED } from 'components/marketplace/savedSearches/featureFlag';
import { SavedSearchesDropdown } from 'components/marketplace/savedSearches/SavedSearchesDropdown';

import type { MapLocation } from './types';

interface MobileHeaderFiltersProps {
  isFocused: boolean;
  selectedLocation?: MapLocation;
  onBack: () => void;
  onOpenFilters: () => void;
  setSelectedLocation: (location?: MapLocation | null) => void;
  selectedAddress?: AddressSearchResultFragment;
  setSelectedAddress: (address?: AddressSearchResultFragment | null) => void;
}

export const MobileHeaderFilters = ({
  isFocused,
  selectedLocation,
  setSelectedLocation,
  onBack,
  onOpenFilters,
  selectedAddress,
  setSelectedAddress,
}: MobileHeaderFiltersProps) => {
  const { closeMenu } = useNavMenu();

  useEffect(() => {
    if (isFocused) {
      closeMenu();
    }
  }, [isFocused, closeMenu]);

  return (
    <Box flexDirection="column">
      {!isFocused && SAVED_SEARCHES_ENABLED && (
        <Box alignSelf="flex-start" mb={4}>
          <SavedSearchesDropdown size="xsmall" />
        </Box>
      )}
      <MapLocationSearch
        selectedAddress={selectedAddress}
        setSelectedAddress={setSelectedAddress}
        setSelectedLocation={setSelectedLocation}
        selectedLocation={selectedLocation}
        isFocused={isFocused}
      />
      <Box
        position="absolute"
        backgroundColor="$backgroundPrimary"
        top={10}
        right="5%"
        zIndex={10000}
      >
        <FilterButton
          size="small"
          analyticsName="cosmos-marketplace-map-header-filter-button"
          onPress={onOpenFilters}
        />
      </Box>
      <Box
        position="absolute"
        backgroundColor="$backgroundPrimary"
        top={10}
        left="2%"
        zIndex={10000}
        display={isFocused ? 'flex' : 'none'}
      >
        <ChevronBackButton
          size="small"
          analyticsName="cosmos-marketplace-map-location-search-back-button"
          onPress={onBack}
        />
      </Box>
    </Box>
  );
};
